import "./index.css";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux'
import { store } from './app/store'
import App from "./App";
import { completeBrowserSignInRedirect, isSilentSignInFrame } from "./BrowserAuth";
import { applyThemeToDocument, getInitialThemeName } from "./theme/AppTheme";

// Applied before the first render so the page does not flash in the light theme.
applyThemeToDocument(getInitialThemeName());

const container = document.getElementById("root");
const root = createRoot(container!);

const renderApp = () => {
    root.render(
        <Provider store={store}>
            <App />
        </Provider>
    );
};

// In the hidden silent sign-in iframe MSAL only needs the URL, so the app is not started there.
if (!isSilentSignInFrame()) {
    completeBrowserSignInRedirect().finally(renderApp);
}
